import SpinnerView from './SpinnerView';

export default SpinnerView;
